/** Safe margin under Express default JSON body limit (100 KB). */
export const BOUNDARY_UPSERT_MAX_BATCH_BYTES = 80_000;

export function estimateJsonByteSize(value: unknown): number {
  return new TextEncoder().encode(JSON.stringify(value)).length;
}

export function chunkByPayloadSize<T>(
  items: T[],
  maxBatchBytes: number,
  estimateItemBytes: (item: T) => number,
): T[][] {
  if (items.length === 0) {
    return [];
  }

  const batches: T[][] = [];
  let currentBatch: T[] = [];
  let currentBatchBytes = 0;

  for (const item of items) {
    const itemBytes = estimateItemBytes(item);

    if (currentBatch.length > 0 && currentBatchBytes + itemBytes > maxBatchBytes) {
      batches.push(currentBatch);
      currentBatch = [];
      currentBatchBytes = 0;
    }

    currentBatch.push(item);
    currentBatchBytes += itemBytes;
  }

  if (currentBatch.length > 0) {
    batches.push(currentBatch);
  }

  return batches;
}

export async function runSequentialBatches<T>(
  batches: T[][],
  runBatch: (batch: T[]) => Promise<void>,
): Promise<void> {
  for (const batch of batches) {
    await runBatch(batch);
  }
}
